/**
 * Identifies internal Whistle Performance staff by email domain.
 * Staff bypass feature-flag gates so they can preview gated features.
 */
export const isStaffEmail = (email?: string | null): boolean =>
  Boolean(
    email?.endsWith("@gpsdataviz.com") ||
      email?.endsWith("@whistleperformance.ai")
  );
